<template>
  <el-form :ref="formName" :model="form" :rules="rules" @submit.native.prevent>
    <el-alert v-if="error" title="Retrieve failed" type="error" :description="error" show-icon></el-alert>
    <h4>Enter your email address to reset your password and retrieve your Membership Number.</h4>
    <el-form-item label="Email" :inline-message="true" prop="email">
      <el-input v-model="form.email" placeholder="Email" size="medium" />
    </el-form-item>
    <div class="form-action">
      <el-button type="primary" class="btn-submit" :disabled="loading" @click="submitForm()">
        Retrieve</el-button>
      <el-button type="text" @click="cancelLogIn">Back to login</el-button>
    </div>
  </el-form>
</template>

<script>
// import axios from 'axios';
import { mapState, mapActions } from 'vuex'
import {submitMixin} from "./_submitMixin"

export default {
  mixins: [submitMixin],
  data() {
    return {
      formName: 'forgotPasswordForm',
      form: { email: '' },
      rules: {
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' },
          { type: 'email', message: 'Please input correct email address', trigger: 'blur' }
        ],
      }
    }
  },
  computed: {
    ...mapState({
      loading: state => state.auth.loading,
      error: state => state.auth.error
    }),
  },
  methods: {
    ...mapActions('auth', ['cancelLogIn', 'requestForgotPassword']),
    submitForm() {
      this.$refs[this.formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }

        await this.requestForgotPassword({ email_address: this.form.email })
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  .el-alert {
    margin-bottom: 15px;
  }

  .el-form-item {
    margin-bottom: 10px !important;

    el-form-item__label {
      line-height: 22px;
      font-weight: bold;
    }

    el-form-item__content {
      .el-form-item__error {
        padding-top: 0;
        padding-bottom: 4px;
      }
    }
  }
}

.form-action {
  margin-top: 30px;

  .btn-submit {
    font-weight: bold;
    font-size: 16px;
    width: 100%;
    padding-top: 18px;
    padding-bottom: 18px;
  }

  .el-button--text {
    margin-left: 0;
    color: #67C23A;
    padding-top: 6px;
    padding-bottom: 0;

    &:hover {
      font-weight: bold;
    }
  }
}
</style>
